var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-3"},[_c('button',{staticClass:"button",on:{"click":_vm.scorePage}},[_vm._v("\n    Score This Page "+_vm._s(_vm.counter)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }